import { useMemo } from 'react';
import { useApi } from '../utils/useApi';
import { useUserContext } from '../contexts/UserContext';
import ReachQueueView, { ReachApi } from '../components/reach/ReachQueueView';

/**
 * Gym-manager surface for Reach AI: full actions against /api/reach.
 * The whole view lives in ReachQueueView (shared with the super-admin
 * read-only preview) — this wrapper only wires auth'd endpoints.
 */
export default function ReachPage() {
  const { fetchWithAuth } = useApi();
  const { userContext, loading: userLoading } = useUserContext();

  const api: ReachApi = useMemo(() => ({
    getToday: async () => (await fetchWithAuth('/api/reach/today')).data,
    unlock: async () => (await fetchWithAuth('/api/reach/unlock', { method: 'POST', body: JSON.stringify({}) })).data,
    getMemberContext: async (memberId: string) => (await fetchWithAuth(`/api/reach/member/${memberId}/context`)).data,
    performAction: async (vars) => (await fetchWithAuth('/api/reach/action', { method: 'POST', body: JSON.stringify(vars) })).data,
    getHistory: async ({ limit, offset }) => (await fetchWithAuth(`/api/reach/history?limit=${limit}&offset=${offset}`)).data
  }), [fetchWithAuth]);

  return (
    <ReachQueueView
      api={api}
      cacheKey="self"
      enabled={!!userContext && !userLoading}
    />
  );
}
